/*
 * Shared selling-plan resolution.
 *
 * Match the group by name instead of taking selling_plan_groups[0]. The .js
 * product endpoint returns every group attached to the product regardless of
 * which app owns it, so as soon as a second group exists the first entry is
 * arbitrary — a customer could end up on a different plan, at a different
 * price, than the product page sells. Falls back to the first group if the
 * named one is missing, so a rename degrades to the old behaviour rather than
 * silently dropping the subscription.
 *
 * The group name comes from snippets/tlh-selling-plan.liquid via
 * window.TLH_SELLING_PLAN, so Liquid and JS cannot disagree about which plan
 * is being sold.
 */
(function () {
  'use strict';

  window.TLH = window.TLH || {};

  function groupName() {
    var cfg = window.TLH_SELLING_PLAN;
    if (cfg && cfg.groupName) return cfg.groupName;
    console.warn(
      '[selling-plan] window.TLH_SELLING_PLAN is missing — render ' +
      "{% render 'tlh-selling-plan' %} in layout/theme.liquid. " +
      'Falling back to the first selling plan group on the product.'
    );
    return null;
  }

  // The subscription price the THEME shows, from the one percentage in
  // snippets/tlh-selling-plan.liquid. Shopify still bills whatever the selling
  // plan's own pricing policy says — these agree only once the plan is updated.
  window.TLH.subscriptionPrice = function (cents) {
    var cfg = window.TLH_SELLING_PLAN || {};
    var pct = Number(cfg.discountPercent);
    if (!isFinite(pct) || pct <= 0 || pct >= 100) return cents;
    return Math.round(cents * (1 - pct / 100));
  };

  // How many free snacks a cart of `jars` premixes earns. The tiers come from
  // snippets/tlh-free-gift.liquid and differ by purchase type: a subscriber
  // earns their first snack two rungs before a one-time buyer, and two at the
  // top rung. Asked in one place so the builder, the cart, and the offer page
  // cannot disagree about what the customer is owed.
  //
  // Tiers are assumed sorted by jars ascending; the last one matched wins.
  window.TLH.giftQty = function (jars, isSubscription) {
    var gift = window.TLH_FREE_GIFT;
    if (!gift || !gift.tiers) return 0;
    var tiers = (isSubscription ? gift.tiers.subscriber : gift.tiers.oneTime) || [];
    var qty = 0;
    for (var i = 0; i < tiers.length; i++) {
      if (jars >= tiers[i].jars) qty = tiers[i].qty;
    }
    return qty;
  };

  window.TLH.resolveSellingPlanId = function (product) {
    var groups = (product && product.selling_plan_groups) || [];
    if (!groups.length) return null;

    var wanted = groupName();
    var named = wanted ? groups.filter(function (g) { return g.name === wanted; })[0] : null;
    var group = named || groups[0];

    if (wanted && !named) {
      console.warn(
        '[selling-plan] group "' + wanted + '" not found on ' +
        ((product && product.handle) || 'product') + ' — falling back to "' + group.name + '". ' +
        'Check snippets/tlh-selling-plan.liquid if the plan was renamed or replaced.'
      );
    }

    return (group.selling_plans && group.selling_plans[0] && group.selling_plans[0].id) || null;
  };
})();
